/**
 * Splits a filename into 'name' and 'extension'.
 *
 * @param {String} filename The filename to split, e.g. `example-file.pdf`.
 * @returns {Object} The filename split into separate 'name' and 'extension' strings.
 */
export default function splitFilename(filename) {
  // Handle extensionless files.
  if (!filename.includes('.')) {
    return {
      name: filename,
      extension: '',
    };
  }

  const lastPeriod = filename.lastIndexOf('.');

  return {
    name: filename.slice(0, lastPeriod),
    extension: filename.slice(lastPeriod + 1),
  };
};
